/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:48:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2021-10-18 16:39:22
 * @Description: 对话框
 * @FilePath: /src/components/confirm/index.js
 */
import confirm from './index.vue';
import Vue from 'vue';

let type = 0;
let el = null;
let successFun = null;
let errorFun = null;

const _confirm = {
    // confirm 打开
    open({
        title = '系统提示',
        message = '',
        confirmText = '确定',
        cancelText = '取消',
        switchBtn = false,
        success = null,
        error = null,
        hideCancelBtn = false,
        isShieldClose = true,
    } = {}) {
        if (el) {
            return;
        }
        let model = Vue.extend(confirm);
        let cfVm = new model();
        cfVm.title = title;
        cfVm.message = message;
        cfVm.confirmText = confirmText;
        cfVm.cancelText = cancelText;
        cfVm.switchBtn = switchBtn;
        cfVm.hideCancelBtn = hideCancelBtn;
        cfVm.isShieldClose = isShieldClose;
        successFun = success;
        errorFun = error;
        el = cfVm.$mount().$el;
        // 插入dom
        if (document.getElementsByClassName('page') && document.getElementsByClassName('page')[1]) {
            type = 3;
            document.getElementsByClassName('page')[1].appendChild(el);
        } else if (
            document.getElementsByClassName('page') &&
            document.getElementsByClassName('page')[0]
        ) {
            type = 2;
            document.getElementsByClassName('page')[0].appendChild(el);
        } else if (document.getElementById('app') && document.getElementById('app')[0]) {
            type = 1;
            document.getElementById('app').appendChild(el);
        } else {
            type = 0;
            document.body.appendChild(el);
        }
    },
    success(data = {}) {
        if (successFun) {
            successFun(data);
        }
    },
    error(data) {
        if (errorFun) {
            errorFun(data);
        }
    },
    close() {
        if (!el) {
            return;
        }
        // 移除dom
        if (type == 3) {
            if (document.getElementsByClassName('page')[1]) {
                document.getElementsByClassName('page')[1].removeChild(el);
            } else {
                document.getElementsByClassName('page')[0].removeChild(el);
            }
        } else if (type == 2) {
            document.getElementsByClassName('page')[0].removeChild(el);
        } else if (type == 1) {
            document.getElementById('app').removeChild(el);
        } else {
            document.body.removeChild(el);
        }
        el = null;
    },
};

export default _confirm;
